<template>
  <v-container fluid grid-list-lg>
    <v-layout>
      <!-- Data table (Devices) -->
      <v-flex xs12 sm6>
        <h3>{{ leftTitle }}</h3>
        <v-text-field
          v-model="leftSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          id="scroll-table"
          v-model="leftSelectedRows"
          class="pl-1"
          :headers="leftHeaders"
          :items="leftItems"
          :search="leftSearch"
          :rows-per-page-items="[-1]"
          hide-actions
        >
          <template v-slot:items="props">
            <tr
              style="transition: background 0s"
              :class="leftSelectedRows.indexOf(props.item.id)>-1? 'grey lighten-2' : ''"
              @click="leftToggleSelection(props.item.id)"
            >
              <td
                v-for="(field, index) in leftHeaders"
                :key="index"
              >{{ genFieldItem(props.item, field) }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-flex>Total {{ totalLeftRecords }} Records</v-flex>
      </v-flex>

      <th width="45px"></th>

      <!-- Move options -->
      <v-layout column>
        <v-icon @click="moveSelectedRight" class="mover-button" x-large>chevron_right</v-icon>
        <v-icon @click="moveAllRight" class="mover-button" x-large>keyboard_double_arrow_right</v-icon>
        <v-icon @click="moveSelectedLeft" class="mover-button" x-large>chevron_left</v-icon>
        <v-icon @click="moveAllLeft" class="mover-button" x-large>keyboard_double_arrow_left</v-icon>
      </v-layout>

      <th width="45px"></th>

      <!-- Data table (Devices in alert groups) -->
      <v-flex xs12 sm6>
        <h3>{{ rightTitle }}</h3>
        <v-text-field
          v-model="rightSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          id="scroll-table"
          v-model="rightSelectedRows"
          class="pr-1"
          :headers="rightHeaders"
          :items="rightItems"
          :search="rightSearch"
          :rows-per-page-items="[-1]"
          hide-actions
        >
          <template v-slot:items="props">
            <tr
              style="transition: background 0s"
              :class="rightSelectedRows.indexOf(props.item.id)>-1? 'grey lighten-2' : ''"
              @click="rightToggleSelection(props.item.id)"
            >
              <td
                v-for="(field, index) in rightHeaders"
                :key="index"
              >{{ genFieldItem(props.item, field) }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-flex>Total {{ totalRightRecords }} Records</v-flex>
      </v-flex>
    </v-layout>

    <th height="45px"></th>

    <!-- Buttons -->
    <v-layout justify-center>
      <v-btn @click="reset" class="error">Reset</v-btn>
      <v-btn @click="submit" class="success">Submit Changes</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'DualSelectLists',
  components: {},
  props: {
    leftTitle: {
      type: String,
      default: null
    },
    leftHeaders: {
      type: Array,
      default: null
    },
    leftItems: {
      type: Array,
      default: null
    },
    rightTitle: {
      type: String,
      default: null
    },
    rightHeaders: {
      type: Array,
      default: null
    },
    rightItems: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      // Search queries
      leftSearch: '',
      rightSearch: '',

      // Rows that have been selected in each list
      leftSelectedRows: [],
      rightSelectedRows: [],

      // Rows that have been moved or removed from each list
      itemsAdded: [],
      itemsRemoved: []
    }
  },

  computed: {
    totalLeftRecords () {
      return this.leftItems.length
    },
    totalRightRecords () {
      return this.rightItems.length
    }
  },

  methods: {
    genFieldItem (item, field) {
      const fieldValues = field.value.split('.')
      if (fieldValues.length === 1) {
        return item[fieldValues[0]]
      } else if (fieldValues.length === 2) {
        // Gets nested values in the returned json data
        return item[fieldValues[0]][fieldValues[1]]
      } else if (fieldValues.length === 3) {
        // Gets nested values in the returned json data
        return item[fieldValues[0]][fieldValues[1]][fieldValues[2]]
      }
    },

    logIds (arr, title) {
      // eslint-disable-next-line no-console
      console.log(title)
      const ids = arr.map(item => {
        return item.id
      })
      // eslint-disable-next-line no-console
      console.log(ids)
    },

    moveSelectedRight () {
      // Remove items from the left where the ID is present in
      // the selected items and create a new list
      const newLeft = this.leftItems.filter(item => {
        return this.leftSelectedRows.indexOf(item.id) === -1
      })

      // Find the selected items and create a new list
      const movedToRight = this.leftItems.filter(item => {
        return this.leftSelectedRows.indexOf(item.id) !== -1
      })

      // Add the found items to the right list and combine with the current
      // right list
      const newRight = [...movedToRight, ...this.rightItems]

      // Update the moved items
      this.itemsAdded = [...this.itemsAdded, ...movedToRight]

      // Reset the selected rows
      this.leftSelectedRows = []

      // Update the left and right lists
      this.$emit('onListChange', { newLeft, newRight })
    },

    moveSelectedLeft () {
      // Remove items from the right where the ID is present in
      // the selected items and create a new list
      const newRight = this.rightItems.filter(item => {
        return this.rightSelectedRows.indexOf(item.id) === -1
      })

      // Find the selected items and create a new list
      const movedToLeft = this.rightItems.filter(item => {
        return this.rightSelectedRows.indexOf(item.id) !== -1
      })

      // Add the found items to the left list and combine with the current
      // left list
      const newLeft = [...movedToLeft, ...this.leftItems]

      // Update the moved items
      this.itemsRemoved = [...this.itemsRemoved, ...movedToLeft]

      // Reset the selected rows
      this.rightSelectedRows = []

      // Update the left and right lists
      this.$emit('onListChange', { newLeft, newRight })
    },

    moveAllLeft () {
      // Copy the right side to a new array
      const movedToLeft = [...this.rightItems]

      // Clear the rightside
      const newRight = []

      // Add the entire right side to the left side
      const newLeft = [...movedToLeft, ...this.leftItems]

      // Update the moved items
      this.itemsRemoved = [...this.itemsRemoved, ...movedToLeft]

      // Reset the selected rows
      this.rightSelectedRows = []

      // Update the right and left lists
      this.$emit('onListChange', { newRight, newLeft })
    },

    moveAllRight () {
      // Copy the left side to a new array
      const movedToRight = [...this.leftItems]

      // Clear the leftside
      const newLeft = []

      // Add the entire left side to the right side
      const newRight = [...movedToRight, ...this.rightItems]

      // Update the moved items
      this.itemsAdded = [...this.itemsAdded, ...movedToRight]

      // Reset the selected rows
      this.leftSelectedRows = []

      // Update the left and right lists
      this.$emit('onListChange', { newLeft, newRight })
    },

    reset () {
    // Search queries
      this.leftSearch = ''
      this.rightSearch = ''

      // Rows that have been selected in each list
      this.leftSelectedRows = []
      this.rightSelectedRows = []

      // Rows that have been moved or removed from each list
      this.itemsAdded = []
      this.itemsRemoved = []

      this.$emit('onReset')
    },

    removeDuplicates () {
      const addedIds = this.itemsAdded.map(item => {
        return item.id
      })
      const removedIds = this.itemsRemoved.map(item => {
        return item.id
      })

      // Find duplicate ids between the two lists
      const duplicates = addedIds.filter(id => {
        return removedIds.indexOf(id) !== -1
      })

      // Remove the duplicates from the added and removed lists
      this.itemsAdded = this.itemsAdded.filter(item => {
        return duplicates.indexOf(item.id) === -1
      })

      this.itemsRemoved = this.itemsRemoved.filter(item => {
        return duplicates.indexOf(item.id) === -1
      })
    },

    submit () {
      // Simplify the lists to just IDs
      this.removeDuplicates()
      this.$emit('onSubmit', {
        itemsAdded: this.itemsAdded,
        itemsRemoved: this.itemsRemoved
      })

      this.itemsRemoved = []
      this.itemsAdded = []
    },

    leftToggleSelection (id) {
      if (this.leftSelectedRows.includes(id)) {
        this.leftSelectedRows = this.leftSelectedRows.filter(
          selectedID => selectedID !== id
        )
      } else {
        this.leftSelectedRows.push(id)
      }
    },

    rightToggleSelection (id) {
      if (this.rightSelectedRows.includes(id)) {
        this.rightSelectedRows = this.rightSelectedRows.filter(
          selectedID => selectedID !== id
        )
      } else {
        this.rightSelectedRows.push(id)
      }
    }
  }
}
</script>

<style>
.mover-button:hover {
  color: #d7ad51;
}
#scroll-table {
  max-height: 350px;
  overflow: auto;
}
</style>
